module.exports = new __parcel__URL__("gicdungri.d68650bb.webp").toString();